module.exports = __webpack_public_path__ + "static/media/benefitCloudRight.32f9e967.svg";